<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM16.5195 8.75977C16.1196 8.36016 15.48 8.36004 15.1201 8.75977L10.7998 13.1201L8.91992 11.2803C8.51992 10.8803 7.87953 10.9203 7.51953 11.2803C7.12009 11.6802 7.16 12.3197 7.51953 12.6797L10.1201 15.2002C10.32 15.4 10.5599 15.4794 10.7998 15.4795C11.0397 15.4795 11.3196 15.3999 11.5195 15.2002L16.5195 10.1602C16.8795 9.76016 16.8795 9.15977 16.5195 8.75977Z"
      fill="currentColor"
    />
  </svg>
</template>
